import type { DragEvent, JSX } from 'react';
import { useState } from 'react';
import { Text, UnstyledButton } from '@mantine/core';

/** The tile with ＋ in front of the newest item; files may be dropped on it. */
export function PlusTile({ label, hint, onClick, onDrop }: { label: string; hint: string; onClick: () => void; onDrop?: (e: DragEvent) => void }): JSX.Element {
  const [over, setOver] = useState(false);
  return (
    <UnstyledButton
      onClick={onClick}
      onDragOver={onDrop ? (e) => { e.preventDefault(); setOver(true); } : undefined}
      onDragLeave={() => setOver(false)}
      onDrop={onDrop ? (e) => { setOver(false); onDrop(e); } : undefined}
      aria-label={label}
      className="pst-tile pst-plus-tile"
      style={{
        borderWidth: 2, borderStyle: 'dashed', borderColor: over ? 'var(--mantine-color-brand-5)' : undefined, borderRadius: 'var(--mantine-radius-md)', minHeight: 140,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4, padding: 12,
        background: over ? 'var(--mantine-color-brand-light)' : undefined,
      }}
    >
      <Text fz={36} lh={1} c="dimmed" aria-hidden>＋</Text>
      <Text size="sm" fw={600}>{label}</Text>
      <Text size="xs" c="dimmed" ta="center">{hint}</Text>
    </UnstyledButton>
  );
}
